import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  Icon,
  UilChartPie,
  UilCube,
  UilDocumentLayoutRight,
  UilFilesLandscapesAlt,
  UilPuzzlePiece
} from '@iconscout/react-unicons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const routes = [
  {
    label: 'dashboard',
    horizontalNavLabel: 'home',
    active: true,
    icon: UilChartPie,
    labelDisabled: true,
    pages: [
      {
        name: 'home',
        icon: 'pie-chart',
        active: true,
        flat: true,
        pages: [
          {
            name: 'sales-management',
            path: '/dashboard/sales-management',
            pathName: 'sales-management-dashboard',
            topNavIcon: 'shopping-cart',
            active: true
          },
          {
            name: 'production-management',
            path: '/dashboard/production-management',
            pathName: 'production-management-dashboard',
            topNavIcon: 'clipboard',
            active: true
          },
          {
            name: 'warehouse-management',
            path: '/dashboard/warehouse-management',
            pathName: 'warehouse-management-dashboard',
            topNavIcon: 'box',
            active: true
          },
          {
            name: 'operator-management',
            path: '/dashboard/operator-management',
            pathName: 'operator-management-dashboard',
            topNavIcon: 'users',
            active: true
          },
          {
            name: 'CRM',
            path: 'dashboard/crm',
            pathName: 'crm',
            topNavIcon: 'phone',
            active: true
          }
        ]
      }
    ]
  },
  {
    label: 'apps',
    icon: UilCube,
    pages: [
      {
        name: 'history',
        active: true,
        icon: 'clock',
        pages: [
          {
            name: 'activity',
            path: '/apps/activity',
            pathName: 'factory-activity',
            active: true
          },
          {
            name: 'reports',
            path: '/apps/reports',
            pathName: 'factory-reports',
            active: true
          }
        ]
      },
      {
        name: 'sales-management',
        active: true,
        icon: 'shopping-cart',
        pages: [
          {
            name: 'create-new',
            path: '/apps/sales-management/create-new',
            pathName: 'sales-management-create-new',
            active: true
          },
          {
            name: 'order-monitor',
            path: '/apps/sales-management/order-monitor',
            pathName: 'sales-management-order-monitor',
            active: true
          },
          {
            name: 'order-list-view',
            path: '/apps/sales-management/order-list-view',
            pathName: 'sales-management-order-list-view',
            active: true
          },
          {
            name: 'order-card-view',
            path: '/apps/sales-management/order-card-view',
            pathName: 'sales-management-order-card-view',
            active: true
          },
          {
            name: 'reservations',
            path: '/apps/sales-management/reservations',
            pathName: 'sales-management-reservations',
            active: true
          },
          {
            name: 'orders-analytics',
            path: '/apps/sales-management/orders-analytics',
            pathName: 'sales-management-orders-analytics',
            active: true
          }
        ]
      },
      {
        name: 'CRM',
        icon: 'phone',
        active: true,
        new: true,
        pages: [
          {
            name: 'analytics',
            path: '/apps/crm/analytics',
            pathName: 'crm-analytics',
            active: true
          },
          {
            name: 'deals',
            path: '/apps/crm/deals',
            pathName: 'crm-deals'
          },
          {
            name: 'deal-details',
            path: '/apps/crm/deal-details',
            pathName: 'crm-deal-details',
            active: true
          },
          {
            name: 'leads',
            path: '/apps/crm/leads',
            pathName: 'crm-leads',
            active: true
          },
          {
            name: 'lead details',
            path: '/apps/crm/lead-details',
            pathName: 'crm-lead-details',
            active: true
          },
          {
            name: 'reports',
            path: '/apps/crm/reports',
            pathName: 'crm-reports',
            active: true
          },
          {
            name: 'report details',
            path: '/apps/crm/report-details',
            pathName: 'crm-report-details',
            active: true
          },
          {
            name: 'add-contact',
            path: '/apps/crm/add-contact',
            pathName: 'crm-add-contact',
            active: true
          }
        ]
      },
      {
        name: 'project-management',
        icon: 'clipboard',
        active: true,
        pages: [
          {
            name: 'create new',
            path: '/apps/project-management/create-new',
            pathName: 'project-management-create-new',
            active: true
          },
          {
            name: 'production-planner',
            path: '/apps/project-management/production-planner',
            pathName: 'project-management-production-planner',
            active: true
          },
          {
            name: 'order-simulation',
            path: '/apps/project-management/order-simulation',
            pathName: 'project-management-order-simulation',
            active: true
          },
          {
            name: 'factory-sync',
            path: '/apps/project-management/factory-sync',
            pathName: 'project-management-factory-sync',
            active: true
          },
          {
            name: 'factory-3d',
            path: '/apps/project-management/factory-3d',
            pathName: 'project-management-factory-3d',
            active: true
          },
          {
            name: 'packing-station',
            path: '/apps/project-management/packing-station',
            pathName: 'project-management-packing-station',
            active: true
          },
          {
            name: 'project-monitor',
            path: '/apps/project-management/project-monitor',
            pathName: 'project-management-project-monitor',
            active: true
          },
          {
            name: 'future-products',
            path: '/apps/project-management/future-products',
            pathName: 'project-management-future-products',
            active: true
          },
          {
            name: 'project-list-view',
            path: '/apps/project-management/project-list-view',
            pathName: 'project-management-project-list-view',
            active: true
          },
          {
            name: 'project-card-view',
            path: '/apps/project-management/project-card-view',
            pathName: 'project-management-project-card-view',
            active: true
          },
          {
            name: 'project-analytics',
            path: '/apps/project-management/project-analytics',
            pathName: 'project-management-project-analytics',
            active: true
          }
        ]
      },
      {
        name: 'machines',
        icon: 'cpu',
        active: true,
        pages: [
          {
            name: 'notifications',
            path: '/apps/machine-management/notifications',
            pathName: 'machine-management-notifications',
            active: true
          },
          {
            name: 'factory-alerts',
            path: '/apps/machine-management/factory-alerts',
            pathName: 'machine-management-factory-alerts',
            active: true
          },
          {
            name: 'machine-monitor',
            path: '/apps/machine-management/machine-monitor',
            pathName: 'machine-management-machine-monitor',
            active: true
          },
          {
            name: 'machine-queues',
            path: '/apps/machine-management/machine-queues',
            pathName: 'machine-management-machine-queues',
            active: true
          },
          {
            name: 'execution-history',
            path: '/apps/machine-management/execution-history',
            pathName: 'machine-management-execution-history',
            active: true
          },
          {
            name: 'machine-traking',
            path: '/apps/machine-management/machine-traking',
            pathName: 'machine-management-machine-traking',
            active: true
          },
          {
            name: 'machine-control',
            path: '/apps/machine-management/machine-control',
            pathName: 'machine-management-machine-control',
            active: true
          },
          {
            name: 'machine-analytics',
            path: '/apps/machine-management/machine-analytics',
            pathName: 'machine-management-machine-analytics',
            active: true
          },
          {
            name: 'machine-deep-dive',
            path: '/apps/machine-management/machine-deep-dive',
            pathName: 'machine-management-machine-deep-dive',
            active: true
          },
          {
            name: 'maintenence',
            path: '/apps/machine-management/maintenence',
            pathName: 'machine-management-maintenence',
            active: true
          }
        ]
      },
      {
        name: 'operators',
        icon: 'users',
        active: true,
        pages: [
          {
            name: 'operator-list',
            path: '/apps/operators/operator-list',
            pathName: 'operators-operator-list',
            active: true
          },
          {
            name: 'operator-performance',
            path: '/apps/operators/operator-performance',
            pathName: 'operators-operator-performance',
            active: true
          },
          {
            name: 'operator-monitor',
            path: '/apps/operators/operator-monitor',
            pathName: 'operators-operator-monitor',
            active: true
          }
        ]
      },
      {
        name: 'drums',
        icon: 'circle',
        active: true,
        pages: [
          {
            name: 'drum-list',
            path: '/apps/drums/drum-list',
            pathName: 'drums-drum-list',
            active: true
          }
        ]
      },
      {
        name: 'warehouse-management',
        icon: 'truck',
        active: true,
        pages: [
          {
            name: 'warehouse-sync',
            path: '/apps/warehouse-management/add-stock',
            pathName: 'warehouse-management-add-stock',
            active: true
          },
          {
            name: 'tasks',
            path: '/apps/warehouse-management/tasks',
            pathName: 'warehouse-management-tasks',
            active: true
          },
          {
            name: 'warehouse-map',
            path: '/apps/warehouse-management/map',
            pathName: 'warehouse-management-map',
            active: true
          },
          {
            name: 'trips',
            path: '/apps/warehouse-management/trips',
            pathName: 'warehouse-management-trips',
            active: true
          },
          {
            name: 'KPIs',
            path: '/apps/warehouse-management/kpis',
            pathName: 'warehouse-management-kpis',
            active: true
          },
          {
            name: 'load-truck-simulator',
            path: '/apps/warehouse-management/load-truck-simulator',
            pathName: 'warehouse-management-load-truck-simulator',
            active: true
          }
        ]
      },
      {
        name: 'material management',
        icon: 'package',
        active: true,
        pages: [
          {
            name: 'raw materials',
            path: '/apps/material-management/raw-materials',
            pathName: 'material-raw-materials',
            active: true
          },
          {
            name: 'upload packing list',
            path: '/apps/material-management/upload-packing-list',
            pathName: 'material-upload-packing-list',
            active: true
          }
        ]
      },
      {
        name: 'standard',
        icon: 'anchor',
        active: true,
        pages: [
          {
            name: 'create new',
            path: 'apps/standard/create-standard',
            pathName: 'standard-create-standard',
            active: true
          },
          {
            name: 'create new (wizard)',
            path: 'apps/standard/create-standard-wizard',
            pathName: 'standard-create-standard-wizard',
            active: true
          },
          {
            name: 'material-catalogue',
            path: 'apps/standard/material-catalogue',
            pathName: 'standard-material-catalogue',
            active: true
          },
          {
            name: 'standard view',
            path: 'apps/standard/view-standard',
            pathName: 'view-standard',
            active: true
          },
          {
            name: 'standard consumption',
            path: 'apps/standard/consumption-standard',
            pathName: 'consumption-standard',
            active: true
          },
          {
            name: 'standard length on drum',
            path: 'apps/standard/length-on-drum-standard',
            pathName: 'length-on-drum-standard',
            active: true
          },
          {
            name: 'stranding calculator',
            path: 'apps/standard/stranding-calculator',
            pathName: 'stranding-calculator',
            active: true
          },
          {
            name: 'standard analytics',
            path: 'apps/standard/analytics',
            pathName: 'standard-analytics',
            active: true
          }
        ]
      }
    ]
  },
  {
    label: 'test interfaces',
    icon: UilPuzzlePiece,
    pages: [
      {
        name: 'operator stations',
        icon: 'printer',
        active: true,
        flat: true,
        pages: [
          {
            name: 'L120 printing labels',
            path: '/test-interfaces/l120-printing-labels',
            pathName: 'test-interfaces-l120-printing-labels',
            topNavIcon: 'printer',
            active: true
          },
          {
            name: 'coils printing station',
            path: '/test-interfaces/coils-printing-station',
            pathName: 'test-interfaces-coils-printing-station',
            topNavIcon: 'layers',
            active: true
          },
          {
            name: 'warehouse reception',
            path: '/test-interfaces/warehouse-reception',
            pathName: 'test-interfaces-warehouse-reception',
            topNavIcon: 'download',
            active: true
          }
        ]
      }
    ]
  }
];
